import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { servicesAction } from "src/store/Slices/Administrator/ServicesSlice";
import AddEditServiceModal from "./Modals/AddEditServiceModal";
import { Image } from "antd";
import fallback from "./fallback.png";
import { copyToClipboard } from "src/components/helpers/copyToClipboard";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Services = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
        {
            key: "3",
            label: "Получить ссылку на изображение",
            onClick: () => {
                copyToClipboard(serviceInfo?.imageUrl?.props?.src);
            },
            // disabled: !mnemo?.children?.find(el => el.mnemo === 'getImageLink')
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Услуга" },
        {
            label: "По наименованию",
            value: 2,
            index: "name",
            title: "Наименование",
        },
        {
            label: "По описанию",
            value: 3,
            index: "description",
            title: "Описание",
        },
        {
            label: "По ссылке на изоброжение",
            value: 4,
            index: "imageUrl",
            title: "Ссылка на изображение",
        },
        {
            label: "По персональной",
            value: 5,
            index: "isPersonal",
            title: "Персональная",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [serviceInfo, setServiceInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const servicesList = useSelector(
        (state) => state.ServicesSlice.servicesList
    );
    const servicesListLoading = useSelector(
        (state) => state.ServicesSlice.servicesListLoading
    );

    const onClickDelete = () => {
        dispatch(
            servicesAction({ flag: "delete", value: { id: serviceInfo.id } })
        ).then(() => {
            dispatch(servicesAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        debugger;
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            servicesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setServiceInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            servicesAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            servicesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(servicesAction({ flag: "get" }));
    }, []);

    const formatedRows = servicesList?.data?.value?.rows.map((element) => ({
        ...element,
        isPersonal: element?.isPersonal ? "Да" : "Нет",
        imageUrl: (
            <Image
                alt="Отсутствует изображение"
                width={120}
                src={element?.imageUrl}
                fallback={
                    fallback || "https://placehold.co/400x400?text=No+Photo"
                }
            />
        ),
    }));

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(servicesAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditServiceModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                serviceInfo={serviceInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={servicesListLoading}
                    onClickRowOne={(record) => {
                        setServiceInfo(record);
                    }}
                    columns={servicesList}
                    rows={formatedRows}
                    total={servicesList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={servicesList}
                    elementsListLoading={servicesListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    onChange={handleTableChange}
                    handlePaginationChange={handlePaginationChange}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Services;
